import { render, staticRenderFns } from "./PressBar.vue?vue&type=template&id=fbf8f07a&scoped=true&"
import script from "./PressBar.vue?vue&type=script&lang=js&"
export * from "./PressBar.vue?vue&type=script&lang=js&"
import style0 from "./PressBar.vue?vue&type=style&index=0&id=fbf8f07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf8f07a",
  null
  
)

export default component.exports